import { render } from "./pieChartFollowFixProblem.vue?vue&type=template&id=45ef08d0&scoped=true"
import script from "./pieChartFollowFixProblem.vue?vue&type=script&lang=js"
export * from "./pieChartFollowFixProblem.vue?vue&type=script&lang=js"

import "./pieChartFollowFixProblem.vue?vue&type=style&index=0&id=45ef08d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ef08d0"]])

export default __exports__